import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconButton, Menu, Typography, MenuItem } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import {
  faCircleQuestion,
  faFilePdf,
  faFileLines,
} from "@fortawesome/free-solid-svg-icons";
import Icon from "../Icon";

import ChevronRight from "../../../images/icons/neutral_edit/Chevron Right.svg";

interface Props {
  userLang: string;
  username: string;
  mail: string;
  pic: String;
}

export const HelpMenu = ({ userLang, username, mail, pic }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //SCアカウント設定
  const handleOpenDisclaimerPage = () => {
    let disclaimerUrl: string;
    if (userLang === "ja") {
      disclaimerUrl = process.env.REACT_APP_DISCLAIMER_URL + "/jp/terms-of-use";
    } else {
      disclaimerUrl = process.env.REACT_APP_DISCLAIMER_URL + "/na/terms-of-use";
    }
    console.log(disclaimerUrl);
    window.open(disclaimerUrl, "_blank");
  };

  const handleSupportLink = () => {
    userLang === "ja"
      ? window.open("https://support-quick3d.smartconstruction.com/hc/ja")
      : window.open("https://support-quick3d.smartconstruction.com/hc/en-us");
  };

  const customColor = {
    color: theme.palette.base.contrast,
  };

  const RightIcon = () => {
    return (
      <div className="del-pj17">
        <Icon imagePath={ChevronRight} color={customColor.color} />
      </div>
    );
  };

  const handleOpenUserManualPage = () => {
    window.open(
      "https://support-quick3d.smartconstruction.com/hc/ja/articles/11060723222937--Smart-Construction-Quick3D-%E3%83%A6%E3%83%BC%E3%82%B6%E3%83%BC%E3%82%AC%E3%82%A4%E3%83%89"
    );
  };

  const customMenuStyles = {
    background: theme.palette.base.menu,
  };

  return (
    <>
      <IconButton className="del-pj19" onClick={handleClick}>
        <FontAwesomeIcon icon={faCircleQuestion} style={customColor} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ top: "0px", borderRadius: "0px" }}
        PaperProps={{ className: "del-pj18", style: customMenuStyles }}
      >
        <MenuItem onClick={handleOpenUserManualPage}>
          <FontAwesomeIcon
            icon={faFilePdf}
            style={{
              width: "16px",
              height: "16px",
              marginRight: "10px",
              ...customColor,
            }}
          />
          {t("USER_MANUAL")}
        </MenuItem>

        <MenuItem onClick={handleOpenDisclaimerPage}>
          <FontAwesomeIcon
            icon={faFileLines}
            style={{
              width: "16px",
              height: "16px",
              marginRight: "10px",
              ...customColor,
            }}
          />
          {t("TERMS_OF_SERVICE")}
        </MenuItem>

        <MenuItem onClick={handleSupportLink}>
          <FontAwesomeIcon
            icon={faCircleQuestion}
            style={{
              width: "16px",
              height: "16px",
              marginRight: "10px",
              ...customColor,
            }}
          />
          {t("SUPPORT")}
        </MenuItem>

        <div
          style={{
            padding: "6px 16px 6px 16px",
            textAlign: "left",
          }}
        >
          <Typography variant="body2">
            {t("VERSION")}
            {process.env.REACT_APP_SC_QUICK3D_VERSION}
          </Typography>
        </div>
      </Menu>
    </>
  );
};
